import { Divider, makeStyles, Theme } from "@material-ui/core";
import {
  DateField,
  SimpleShowLayout,
  TextField as RaTextField,
} from "react-admin";
import { EldDeviceParsedMessageDto } from "../../../common/data/service-proxies";
import { EldDeviceParsedMessageErrorField } from "./EldDeviceParsedMessageErrorField";
import { EldMessageLocationField } from "./EldMessageLocationField";
import "./ShowEldMessageDetailsFields.css";

interface Props {
  record?: EldDeviceParsedMessageDto;
}

const useStyles = makeStyles<Theme>((theme) => ({
  monotype: {
    fontFamily: "consolas, monotype",
    overflowWrap: "break-word",
  },
}));

export const ShowEldMessageDetailsFields = ({ record, ...props }: Props) => {
  const classes = useStyles();
  return (
    <SimpleShowLayout record={record} {...props}>
      <EldDeviceParsedMessageErrorField error={record?.error} />
      <RaTextField source="messageReason" />
      <DateField showTime source="utcTimestamp" label="Message sent at" />
      <DateField showTime source="timestamp" label="Message received at" />
      <RaTextField source="message" className={classes.monotype} />
      <Divider />
      <EldMessageLocationField
        label="Location"
        location={record?.parsedMessage}
      />
      {record?.parsedMessage
        ? Object.getOwnPropertyNames(record.parsedMessage).map((prop) =>
            record.parsedMessage![prop] ? (
              <RaTextField label={prop} source={`parsedMessage.${prop}`} />
            ) : null
          )
        : null}
    </SimpleShowLayout>
  );
};
